<template>
    <div class="admin-login-component container">
        <div class="login-form-wrapper">
            <h4 class="login-box-title">Login</h4>
            <div class="login-form-inner row">
                <form v-if="!showPhoneLogin" class="col-12">
                    <div class="row my-3">
                        <div class="col-12">
                            <!-- <input
                                class="col-12 w-100 pl-3"
                                v-model="email"
                                v-on:keyup.enter="onLogin"
                                type="email"
                                name="email"
                                placeholder="Email"
                                autocomplete="username"
                                required
                            />
                            <span class="input-stripe-border"></span> -->

                            <input class="col-12 w-100 pl-3" :class="emailError ? 'error' : ''" v-model="email"
                                type="email" name="email"
                                :placeholder="emailError ? emailErrorMessage : 'E-mail Address'" autocomplete="username"
                                @input="clearError('email')" @keyup.enter="onRegister" />
                            <span v-if="!emailError" class="input-stripe-border"></span>
                            <span v-if="emailError" class="input-stripe-border-red"></span>
                        </div>
                    </div>
                    <div class="row my-3">
                        <!-- <div class="col-12">
                            <input
                                class="w-100 pl-3"
                                v-model="password"
                                v-on:keyup.enter="onLogin"
                                type="password"
                                name="password"
                                placeholder="Password"
                                autocomplete="current-password"
                                required
                            />
                            <span class="input-stripe-border"></span>
                        </div> -->
                        <div class="col-12">
                            <input class="col-12 w-100 pl-3" :class="passwordError ? 'error' : ''" v-model="password"
                                type="password" name="password"
                                :placeholder="passwordError ? passwordErrorMessage : 'Password'"
                                @input="clearError('password')" @keyup.enter="onLogin"
                                autocomplete="current-password" />
                            <span v-if="!passwordError" class="input-stripe-border"></span>
                            <span v-if="passwordError" class="input-stripe-border-red"></span>
                        </div>
                    </div>
                    <div class="row my-3">
                        <label
                            class="col-12 text-center d-flex align-items-center justify-content-center remember-me-wrap">
                            <input v-model="remember" type="checkbox" checked="checked" name="remember" value="1" />
                            <span class="ml-2">Keep Me Logged In</span>
                        </label>
                    </div>
                    <div class="row my-3">
                        <div class="col-12 text-center">
                            <button class="login-button" type="button" v-on:click="
                                onLogin();
                            scrollToTop();
                            ">
                                Login
                            </button>
                        </div>
                    </div>
                    <div class="row my-3">
                        <label class="col-12 text-center d-flex align-items-center justify-content-center">
                            <strong>or</strong>
                        </label>
                    </div>
                    <div class="row my-3">
                        <div class="col-12 text-center">
                            <button class="login-button" type="button" v-on:click="showPhoneLogin = true">
                                Login with Phone Number
                            </button>
                        </div>
                    </div>
                </form>
                <form v-if="showPhoneLogin" class="col-12">
                    <phone-login @back="showPhoneLogin = false"></phone-login>
                </form>
                <div class="col-12">
                    <div class="row my-3">
                        <div class="col-12 forgot-password-text text-center">
                            <br><br>
                            <router-link :to="{ path: '/app/forgot-password' }">{{
                                $t("adminMenu.forgotPassword")
                                }}</router-link>
                        </div>
                    </div>
                    <div class="row my-3">
                        <div class="col-12 forgot-password-text text-center">
                            <span>Don't have an account yet? </span><br>
                            Click to
                            <router-link :to="{ path: '/app/register' }">{{
                                $t("adminMenu.register")
                                }}</router-link>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import auth from "./../../services/auth.js";
import store from "./../../services/vuex.js";
import eventBus from "../../services/eventBus.js";
import phoneLogin from './PhoneLogin.vue';

export default {
    name: "AccountLogin",
    data: function () {
        return {
            email: "",
            password: "",
            remember: 0,
            showPhoneLogin: false,

            emailError: false,
            passwordError: false,
            emailErrorMessage: '',
            passwordErrorMessage: '',
        };
    },
    mounted: function () {
        if (auth.state.user) {
            this.$router.push("/app");
        }
        this.scrollToTop();

        if (typeof this.$route.query.email != "undefined") {
            this.email = this.$route.query.email;
        }

        eventBus.on("user_profile_loaded", this.onLoggedIn);
    },
    beforeUnmount() {
        eventBus.off("user_profile_loaded", this.onLoggedIn);
    },
    components: {
        phoneLogin
    },
    computed: {
        selectedStylist: {
            get: function () {
                return this.$store.state.selectedStylist;
            },
            set: function (value) {
                this.$store.commit("setSelectedStylist", value);
            },
        },
    },
    methods: {
        onLogin: function () {
            // Validate all required fields
            const formIsValid = this.validateForm();

            // If form is invalid, stop here (fields will be highlighted automatically)
            if (!formIsValid) {
                return;
            }

            auth.login({ email: this.email, password: this.password, remember: this.remember }, true);
        },
        onLoggedIn: function () {
            this.$router.push("/app");
        },
        scrollToTop() {
            const duration = 800; // Scroll duration in milliseconds
            const start = window.scrollY;
            const startTime = "now" in window.performance ? performance.now() : new Date().getTime();

            const scrollToTop = (timestamp) => {
                const elapsed = timestamp - startTime;
                const progress = Math.min(elapsed / duration, 1);
                const easeInOutCubic = (t) => (t < 0.5 ? 4 * t * t * t : (t - 1) * (2 * t - 2) * (2 * t - 2) + 1);
                window.scrollTo(0, start + (0 - start) * easeInOutCubic(progress));

                if (elapsed < duration) {
                    requestAnimationFrame(scrollToTop);
                }
            };

            requestAnimationFrame(scrollToTop);
        },
        // Simple check if field is not empty
        validateField(value) {
            return value && value.toString().trim() !== '';
        },

        // Validate all fields and set errors/messages
        validateForm() {
            // Email
            if (!this.validateField(this.email)) {
                this.emailError = true;
                this.emailErrorMessage = 'Please enter your email';
            } else {
                this.emailError = false;
                this.emailErrorMessage = '';
            }

            // Password
            if (!this.validateField(this.password)) {
                this.passwordError = true;
                this.passwordErrorMessage = 'Please enter a password';
            } else {
                this.passwordError = false;
                this.passwordErrorMessage = '';
            }

            // Return true if all fields are valid
            return !(

                this.emailError ||
                this.passwordError
              
            );
        },
        // Reset error on input
        clearError(field) {
            this[`${field}Error`] = false;
            this[`${field}ErrorMessage`] = '';
        },
    },
};
</script>
